import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onCreateProfile,
  onDeleteProfile,
  onGetProfile,
  onGetProfileByUserId,
  onUpdateProfile,
} from '../../../app/modules/profile/core/_requests'
interface ProfileState {
  profile: any
}
const initialState = {
  profile: null,
} as ProfileState

export const fetchProfile = createAsyncThunk('profile/fetchProfile', async () => {
  const data: any = await onGetProfile()
  return data.data.result
})

export const fetchProfileById = createAsyncThunk('profile/fetchProfileById', async (param: any) => {
  const data: any = await onGetProfileByUserId(param)
  return data.data.result
})

export const updateProfile = createAsyncThunk('profile/updateProfile', async (param: any) => {
  const data: any = await onUpdateProfile(param)
  return data.data
})

export const createProfile = createAsyncThunk('profile/createProfile', async (param: any) => {
  const data: any = await onCreateProfile(param)
  return data.data
})

export const deleteProfile = createAsyncThunk('profile/deleteProfile', async (param: any) => {
  const data: any = await onDeleteProfile(param)
  return data.data
})

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.profile = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProfile.fulfilled, (state: any, action) => {
      state.profile = action.payload
    })
    builder.addCase(fetchProfileById.fulfilled, (state: any, action) => {
      state.profile = action.payload
    })
  },
})

export const {clearProfile} = profileSlice.actions

export default profileSlice.reducer
